import * as React from 'react';

import Grid, { GridProps } from '@mui/material/Grid';

import { ActionContainer, ActionContainerProps } from './actionContainer/actionContainer';
import { Aside, AsideProps } from './aside/aside';
import { MainContent, MainContentProps } from './mainContent/mainContent';
import { PageContainer, PageContainerProps } from './pageContainer/pageContainer';

type Composition = {
  ActionContainer: React.FC<ActionContainerProps>;
  Aside: React.FC<AsideProps>;
  MainContent: React.FC<MainContentProps>;
  PageContainer: React.FC<PageContainerProps>;
};

type NestedPageLayoutProps = {
  children?: React.ReactNode;
} & GridProps;

export const NestedPageLayout: React.FC<NestedPageLayoutProps> & Composition = ({
  children,
  ...props
}) => {
  return (
    <Grid container {...props}>
      {children}
    </Grid>
  );
};

NestedPageLayout.Aside = Aside;
NestedPageLayout.MainContent = MainContent;
NestedPageLayout.PageContainer = PageContainer;
NestedPageLayout.ActionContainer = ActionContainer;
